// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"9f0d0ecb","3938":"5429a02a"}[chunkId] + ".chunk.css";
};